// Types
import { RootState } from 'types/RootState.types';

export const getAccountCreationSuccessErrorSelector = (state: RootState) =>
  state.createAccount?.accountCreationSuccessError;
export const getJoinMyJLFailedSelector = (state: RootState) => state.createAccount?.joinMyJLFailed || false;
export const getJoinMyJLSuccessSelector = (state: RootState) => state.createAccount?.joinMyJLApiCallComplete || false;
export const getUserAddressSelector = (state: RootState) => state.createAccount?.userAddress;
export const getMyJLContentIndexSelector = (state: RootState) => state.createAccount?.myJLContentIndex ?? 0;
export const getMyJLMemberStatusSelector = (state: RootState) => state.createAccount?.myJLMemberStatus ?? '';
export const getMyJLModalOpenSelector = (state: RootState) => state.createAccount?.myJLModalOpen || false;
